/** Минимальная форма записи пользователя для отображения в бейджах/аватарах. */
export type AssigneeMatchMeta = {
  login: string;
  displayName: string | null;
  isRegistered: boolean;
  userId: number | null;
};

/** Нормализация для сравнения: trim, lower, схлопывание пробелов. */
export function normalizeAssigneeKey(raw: string): string {
  return raw.trim().toLowerCase().replace(/\s+/g, ' ');
}

const AVATAR_PALETTE = [
  '#0055A5',
  '#00A651',
  '#E85D04',
  '#6F42C1',
  '#D0021B',
  '#0F766E',
  '#B45309',
  '#5A5E66',
];

export function colorForAssignee(key: string): string {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length]!;
}

export function initialsFor(name: string): string {
  const s = name.trim();
  if (!s) return '•';
  // Если это email — берём первые 2 символа ДО @.
  if (s.includes('@')) {
    const local = s.split('@')[0] ?? '';
    return local.slice(0, 2).toUpperCase() || '•';
  }
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0]!.slice(0, 2).toUpperCase();
  }
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

export function preferredAssigneeLabel(
  raw: string,
  match: AssigneeMatchMeta | null,
): string {
  if (match?.displayName && match.displayName.trim()) return match.displayName.trim();
  const r = raw.trim();
  if (r) return r;
  return match?.login ?? '—';
}
